export type Trigger =
  | "call_outcome"
  | "deal_stage_changed"
  | "deal_created"
  | "no_activity"
  | "email_event"
  | "meeting_note_matched"
  | "schedule";
export type Op =
  | "eq"
  | "neq"
  | "in"
  | "nin"
  | "gt"
  | "gte"
  | "lt"
  | "lte"
  | "exists"
  | "not_exists"
  | "contains"
  | "days_since_gte"
  | "matches";
export const OPS: readonly Op[] = [
  "eq",
  "neq",
  "in",
  "nin",
  "gt",
  "gte",
  "lt",
  "lte",
  "exists",
  "not_exists",
  "contains",
  "days_since_gte",
  "matches",
];
export type ValueRef = { ref: string };
export type Leaf = { field: string; op: Op; value?: unknown };
export type Condition = Leaf | { all: Condition[] } | { any: Condition[] };
export type TraceEntry = {
  field: string;
  op: Op;
  expected: unknown;
  actual: unknown;
  result: boolean;
};

export type Delay =
  | { business_days: number; at: string }
  | { minutes: number }
  | { hours: number }
  | { before: string; hours: number }
  | { from: string };

export type ActionType =
  | "set_callback"
  | "set_prospect_status"
  | "cool_down"
  | "create_task"
  | "create_deal"
  | "move_deal"
  | "add_note"
  | "enroll_sequence"
  | "stop_sequences"
  | "send_email"
  | "create_calendar_event"
  | "notify_teams"
  | "notify_user"
  | "suppress"
  | "ai_draft";
export const ACTION_TYPES: readonly ActionType[] = [
  "set_callback",
  "set_prospect_status",
  "cool_down",
  "create_task",
  "create_deal",
  "move_deal",
  "add_note",
  "enroll_sequence",
  "stop_sequences",
  "send_email",
  "create_calendar_event",
  "notify_teams",
  "notify_user",
  "suppress",
  "ai_draft",
];
export const EDGE_ACTIONS: readonly ActionType[] = [
  "send_email",
  "create_calendar_event",
  "ai_draft", // GAVION ai-email: queues a draft (never sends)
];
export type ActionSpec = {
  type: ActionType;
  delay?: Delay;
  [param: string]: unknown;
};

export type AutomationRule = {
  id: number;
  key?: string | null;
  name: string;
  description?: string | null;
  trigger: Trigger;
  conditions: unknown;
  actions: ActionSpec[];
  enabled: boolean;
  position: number;
  is_default: boolean;
};
export type AutomationEvent = {
  id: number;
  trigger: Trigger;
  entity_type: string;
  entity_id: number;
  event_id: string;
  context: Record<string, unknown>;
  created_at: string;
};
